import { createFeatureSelector } from '@ngrx/store';

import * as auth from './reducers/auth.reducers';
import * as user from './reducers/user.reducers';
import * as lilate from './reducers/lilate.reducers';
import * as createFormations from './reducers/createFormations.reducers';
import * as exercises from './reducers/exercise.reducers';
import * as examination from './reducers/examination.reducers';
import * as slideText from './reducers/slide-text.reducers';
import * as examinationSession from './reducers/examination_session.reducers';
import * as websockets from './reducers/websockets.reducers';
import * as chart from './reducers/chart.reducers';
import * as elate from './reducers/elate.reducers';
import * as formation from './reducers/formation.reducers';
import * as group from './reducers/group.reducers';
import * as routePermission from './reducers/routePermission.reducers';

export interface SharedAppState {
  auth: auth.AuthData;
  user: user.UserData;
  lilate: lilate.LilateData;
  elate: elate.ElateData;
  examination: examination.ExaminationsData
  exercises: exercises.ExercisesData,
  examinationSession: examinationSession.ExaminationSessionsData,
  slideText: slideText.SlideTextsData,
  websockets: websockets.WebSocketState,
  chart: chart.ChartData;
  formation: formation.FormationState;
  group: group.GroupState;
  routePermission: routePermission.RoutePermissionState;
}

export const reducers = {
  auth: auth.reducer,
  user: user.reducer,
  lilate: lilate.reducer,
  elate: elate.reducer,
  exercises: exercises.reducer,
  examination: examination.reducer,
  examinationSession: examinationSession.reducer,
  slideText: slideText.reducer,
  websockets: websockets.webSocketReducer,
  chart: chart.reducer,
  formation: formation.formationReducer,
  group: group.groupReducer,
  routePermission: routePermission.routePermissionReducer,
};

export const selectAuthState = createFeatureSelector<SharedAppState>('auth');
export const selectUserState = createFeatureSelector<SharedAppState>('user');
export const selectLilateState = createFeatureSelector<SharedAppState>('lilate');
export const selectExerciseState = createFeatureSelector<SharedAppState>('exercises');
export const selectExaminationState = createFeatureSelector<SharedAppState>('examination');
export const selectExaminationSessionState = createFeatureSelector<SharedAppState>('examinationSession');
export const selectSlideText = createFeatureSelector<SharedAppState>('slideText');
export const selectWebsockets = createFeatureSelector<SharedAppState>('websockets');
export const selectChart = createFeatureSelector<SharedAppState>('chart');
export const selectElateState = createFeatureSelector<SharedAppState>('elate');

export interface CreateFormationsState {
  createFormationsState: createFormations.data;
}

export const CreateFormationsReducers = {
  createFormationsState: createFormations.reducer,
};
export const CreateFormationsState = createFeatureSelector<CreateFormationsState>('createFormations');
